<template>
  <BaseModal
    :is-open="isOpen"
    title="Add Meal"
    size="md"
    @close="handleClose"
    @dismiss="handleClose"
  >
    <div class="adhoc-modal">
      <p class="adhoc-copy">Add a meal to this day.</p>

      <div class="adhoc-fields">
        <BaseInput
          v-model="titleInput"
          type="text"
          label="Meal name"
          placeholder="e.g. Pre-workout snack"
          autocomplete="off"
        />
        <BaseInput
          v-model="plannedAtInput"
          type="time"
          label="Time"
        />
      </div>

      <div class="adhoc-actions">
        <BaseButton variant="ghost" size="md" @click="handleClose">Cancel</BaseButton>
        <BaseButton variant="primary" size="md" :disabled="!canSave" @click="handleSave">
          Add meal
        </BaseButton>
      </div>
    </div>
  </BaseModal>
</template>

<script setup lang="ts">
import { ref, computed, watch } from 'vue';
import BaseModal from '@/components/ui/BaseModal.vue';
import BaseInput from '@/components/ui/BaseInput.vue';
import BaseButton from '@/components/ui/BaseButton.vue';
import { formatTimeInput, toUtcIsoFromLocalDateTime } from '@/utils/dateTime';

const props = defineProps<{
  isOpen: boolean;
  date: string;
}>();

const emit = defineEmits<{
  close: [];
  save: [{ title: string; plannedAt: string }];
}>();

const titleInput = ref('');
const plannedAtInput = ref('');

const now = () => formatTimeInput(new Date());

watch(() => props.isOpen, (open) => {
  if (open) {
    titleInput.value = '';
    plannedAtInput.value = now();
  }
});

const canSave = computed(() => titleInput.value.trim().length > 0);

const handleClose = () => emit('close');

const handleSave = () => {
  if (!canSave.value) return;
  const timeStr = plannedAtInput.value || now();
  const plannedAt = toUtcIsoFromLocalDateTime(props.date, timeStr);
  emit('save', { title: titleInput.value.trim(), plannedAt });
};
</script>

<style scoped>
.adhoc-modal {
  display: flex;
  flex-direction: column;
  gap: var(--space-lg);
}

.adhoc-copy {
  color: var(--color-text-secondary);
  font-size: var(--font-size-sm);
  margin: 0;
}

.adhoc-fields {
  display: flex;
  flex-direction: column;
  gap: var(--space-md);
}

.adhoc-actions {
  display: flex;
  justify-content: flex-end;
  gap: var(--space-sm);
}
</style>
